/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {List} from 'immutable';
import {increaseProduct, decreaseProduct, setPcsKeyboard, increaseProductHalf} from '../../common/categories/actions';

class NumKeyboard extends React.Component {

    static propTypes = {
        increaseProduct: React.PropTypes.func,
        decreaseProduct: React.PropTypes.func,
        increaseProductHalf: React.PropTypes.func,
        setPcsKeyboard: React.PropTypes.func
    };

    render() {
        const {setPcsKeyboard, increaseProduct, decreaseProduct, increaseProductHalf} = this.props;

        const nums = List.of(1, 2, 3, 4, 5, 6, 7, 8, 9);

        return (
            <section className="numpad" id="keyboard">
                {nums.map(i =>
                  <div className="numpad-key" key={`keyboars-${i}`}>
                    <div className="boxBtn color-green text-xl text-b" onClick={() => setPcsKeyboard(i)}>
                        <div className="boxBtn-inner">
                            {i}
                        </div>
                    </div>
                  </div>
                )}
              <div className="numpad-key view-half">
                <div className="boxBtn color-greenLight text-xl text-b" onClick={() => decreaseProduct()}>
                    <div className="boxBtn-inner">
                        -
                    </div>
                </div>
              </div>
              <div className="numpad-key">
                <div className="boxBtn color-green text-xl text-b" onClick={() => setPcsKeyboard(0)}>
                    <div className="boxBtn-inner">
                        0
                    </div>
                </div>
              </div>
              <div className="numpad-key">
                <div className="boxBtn color-green text-xl text-b" onClick={() => increaseProductHalf()}>
                    <div className="boxBtn-inner">
                        .5
                    </div>
                </div>
              </div>
              <div className="numpad-key view-half">
                <div className="boxBtn color-greenLight text-xl text-b" onClick={() => increaseProduct()}>
                    <div className="boxBtn-inner">
                        +
                    </div>
                </div>
              </div>
            </section>
        );
    }
}

export default connect(state => ({}), {increaseProduct, decreaseProduct, setPcsKeyboard,
    increaseProductHalf})(NumKeyboard);



// WEBPACK FOOTER //
// ./src/browser/home/NumKeyboard.js